import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function usePropertyDetailsEnabled() {
  const localization = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.MeasureAI),
  )

  return localization?.enabled ?? false
}
